import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

const Item = Form.Item

export default class SpaceAddModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////   

    static propTypes = {
        setForm: PropTypes.func.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        this.props.setForm(this.fm)
    }

    /////////////////////////////////////////////////////////////
        
    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 15 }
        }
        return (
            <div>
                <Form ref={this.fm}>
                    <Item
                        {...formItemLayout}
                        label="地點"
                        name="SpaceName"
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入地點' },
                        ]}
                    >
                        <Input placeholder="地點名稱" />
                    </Item>
                </Form>
            </div>
        )
    }
}